import { render, staticRenderFns } from "./EmbededElement.vue?vue&type=template&id=beb3f670"
import script from "./EmbededElement.vue?vue&type=script&lang=js"
export * from "./EmbededElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports